import { render, staticRenderFns } from "./ContactLeft.vue?vue&type=template&id=5d8443bc&scoped=true"
import script from "./ContactLeft.vue?vue&type=script&lang=js"
export * from "./ContactLeft.vue?vue&type=script&lang=js"
import style0 from "./ContactLeft.vue?vue&type=style&index=0&id=5d8443bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8443bc",
  null
  
)

export default component.exports